import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import Loading from "../../components/common/Loading";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  GetAttendanceReport,
  GetAttendanceReportMobilePunch,
  getCategorys,
  getCompanys,
  getDepartments,
  getDesignation,
  getEditReport,
  getGroup,
  getPages,
  getProfitCenter,
  getPunchRecords,
} from "../../services/dataService";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import "jspdf-autotable";
import FilterComponent from "../pages/FilterComponent";
import { IconFilter } from "@tabler/icons-react";
import toast from "react-hot-toast";
import { Link, useLocation } from "react-router-dom";

export default function MobilePunchReport() {
  const [dates, setDates] = useState({
    FromDate: "",
    ToDate: "",
  });
  const [data, setData] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [AttendenceReports, setAttendenceReports] = useState([]);
  const [locationCache, setLocationCache] = useState({}); // Cache for locations
  const UID = localStorage.getItem("userId");
  const departmentIds = localStorage.getItem("DepartmentId") || "";
  const DepId = departmentIds.split(",")[0] || null;
  const isAdmin = localStorage.getItem("IsAdmin");
  const UserName = localStorage.getItem("UserName");
  const [editedReport, setEditedReport] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [dataFilter, setDataFilter] = useState([]);
  const [PunchRecords, setPunchRecords] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [dashboarditems, setDashboarditems] = useState([]);

  const location = useLocation();
  const DatefromDashboard = location.state?.MobilePunch;

  useEffect(() => {
    if (!DatefromDashboard) {
      // redirect or set default date
      console.warn("No MobilePunch passed from dashboard");
    }
    setDashboarditems(DatefromDashboard);
  }, [DatefromDashboard]);
  // Fetch company details
  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0]);
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("An error occurred while fetching company details");
    }
  };


 

  const fetchPunchRecords = async () => {
    const datesr = {
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
    };
    try {
      setLoading(true);
      const result = await getPunchRecords(datesr);
      setPunchRecords(result.data.data || []);
    } catch (error) {
      console.log("punch rec error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDates((prevDates) => ({
      ...prevDates,
      [name]: value,
    }));
  };

  const fetchAttendanceReport = async () => {
    const data = {
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
      UserId: UID,
    };

    try {
      setLoading(true);
      const response = await GetAttendanceReportMobilePunch(data);
      const details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DEPARTMENTID == DepId);
      const MobilePunch = details.filter(
        (el) => el.PunchIP == 1000 || el.IpAddressOut == 1000
      );
      console.log(MobilePunch, "sasa");

      setAttendenceReports(
        dashboarditems?.length > 0 ? dashboarditems : MobilePunch ?? []
      );
      // Fetch locations for the new attendance data
    } catch (error) {
      console.error("Error fetching attendance data", error);
    } finally {
      setLoading(false);
    }
  };

  const fetcheditedInandout = async () => {
    const data = {
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
      UserId: UID,
    };

    try {
      setLoading(true);
      const response = await getEditReport(data);
      const details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DEPARTMENTID == DepId);
      setEditedReport(details);
    } catch (error) {
      console.error("Error fetching Editedreport data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    fetchAttendanceReport();
    fetcheditedInandout();
  };

  useEffect(() => {
    setDates({
      FromDate: new Date().toISOString().split("T")[0],
      ToDate: new Date().toISOString().split("T")[0],
    });
    fetchAttendanceReport();
    fetcheditedInandout();
  }, [UID]);

  const columnsFilter = [
    {
      name: "Sl No",
      cell: (row, index) => {
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "E_Name",
      selector: (row) => row.EmployeeName,
      sortable: true,
    },
    {
      name: "E_Code",
      selector: (row) => row.EmployeeCode,
      sortable: true,
    },
    {
      name: "Shift",
      selector: (row) => (row.IsWeekly == 1 ? "Weekly Off" : row.ShiftName),
      sortable: true,
    },
    {
      name: "E_Department",
      selector: (row) => row.DepartmentName,
      sortable: true,
    },
    {
      name: "Record date",
      selector: (row) => {
        const date = new Date(row.RECORDDATE);
        return `${date.getDate().toString().padStart(2, "0")}/${(
          date.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${date.getFullYear()}`;
      },
      sortable: true,
    },
    {
      name: "In Time",
      selector: (row) => {
        if (!row.INTIME) return "-";
        const time = row.INTIME.split("T")[1]?.slice(0, 5);
        return time || "-";
      },
      sortable: true,
      cell: (row) => {
        if (!row.INTIME) return "-";
        const time = row.INTIME.split("T")[1]?.slice(0, 5);
        return time || "-";
      },
    },
    {
      name: "Out Time",
      selector: (row) => {
        if (!row.OUTTIME) return "-";
        const time = row.OUTTIME.split("T")[1]?.slice(0, 5);
        return time || "-";
      },
      sortable: true,
      cell: (row) => {
        if (!row.OUTTIME) return "-";
        const time = row.OUTTIME.split("T")[1]?.slice(0, 5);
        return time || "-";
      },
    },
    {
      name: "Punch In",
      selector: (row) => {
        if (!row?.PUNCHIN) return "-";
        const time = row?.PUNCHIN.split("T")[1]?.slice(0, 5);
        return time || "-";
      },
      sortable: true,
      cell: (row) => {
        if (!row?.PUNCHIN) return "-";
        const time = row?.PUNCHIN.split("T")[1]?.slice(0, 5);
        return time || "-";
      },
    },
    {
      name: "Punch Out",
      selector: (row) => {
        if (!row?.PUNCHOUT) return "-";
        const time = row?.PUNCHOUT.split("T")[1]?.slice(0, 5);
        return time || "-";
      },
      sortable: true,
      cell: (row) => {
        if (!row?.PUNCHOUT) return "-";
        const time = row?.PUNCHOUT.split("T")[1]?.slice(0, 5);
        return time || "-";
      },
    },
    {
      name: "WorkingHour",
      selector: (row) => {
        const decimalHour = parseFloat(row.WORKINGHOUR || 0);
        const hours = Math.floor(decimalHour);
        const remainingMinutes = (decimalHour - hours) * 60;
        const minutes = Math.floor(remainingMinutes);
        const seconds = Math.floor((remainingMinutes - minutes) * 60);

        const hh = hours.toString().padStart(2, "0");
        const mm = minutes.toString().padStart(2, "0");
        const ss = seconds.toString().padStart(2, "0");

        return `${hh}:${mm}`;
      },
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) =>
        row.ATTENDANCESTATUS === 1
          ? (!row.PUNCHIN || row.PUNCHIN === "1900-01-01T00:00:00.000Z") &&
            (!row.PUNCHOUT || row.PUNCHOUT === "1900-01-01T00:00:00.000Z")
            ? "Approved (No Punches)"
            : (!row.PUNCHIN || row.PUNCHIN === "1900-01-01T00:00:00.000Z") &&
              row.PUNCHOUT !== "1900-01-01T00:00:00.000Z"
            ? "Approved (Punch out Only)"
            : row.PUNCHIN !== "1900-01-01T00:00:00.000Z" &&
              (!row.PUNCHOUT || row.PUNCHOUT === "1900-01-01T00:00:00.000Z")
            ? "Approved (Punch In Only)"
            : "Approved"
          : "Approval Pending",
      sortable: true,
      cell: (row) => (
        <span
          className={`px-2 py-1 rounded ${
            row.ATTENDANCESTATUS === 1
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {row.ATTENDANCESTATUS === 1
            ? (!row.PUNCHIN || row.PUNCHIN === "1900-01-01T00:00:00.000Z") &&
              (!row.PUNCHOUT || row.PUNCHOUT === "1900-01-01T00:00:00.000Z")
              ? "Approved (No Punches)"
              : (!row.PUNCHIN || row.PUNCHIN === "1900-01-01T00:00:00.000Z") &&
                row.PUNCHOUT !== "1900-01-01T00:00:00.000Z"
              ? "Approved (Punch out Only)"
              : row.PUNCHIN !== "1900-01-01T00:00:00.000Z" &&
                (!row.PUNCHOUT || row.PUNCHOUT === "1900-01-01T00:00:00.000Z")
              ? "Approved (Punch In Only)"
              : "Approved"
            : "Approval Pending"}
        </span>
      ),
    },
    {
      name: "Location IN",
      grow: 0,
      width: "260px",
      selector: (row) => row.MobilePunchLocation || "-",
      sortable: false,
      cell: (row) => (
        <div className="flex flex-col text-sm">
          <span>{row.MobilePunchLocation || "-"}</span>
        </div>
      ),
    },
    {
      name: "Location OUT",
      grow: 0,
      width: "260px",
      selector: (row) => row.LocationOut || "-",
      sortable: false,
      cell: (row) => (
        <div className="flex flex-col text-sm">
          <span>{row.LocationOut || "-"}</span>
        </div>
      ),
    },

    {
  name: "View Location",
  grow: 0,
  width: "200px",
  cell: (row) => {
    const inLoc = row?.MobilePunchLocation;
    const outLoc = row?.LocationOut;

    const openMap = (loc) => {
      if (!loc) return;
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc)}`,
        "_blank"
      );
    };

    return (
      <div className="flex gap-2">
        {inLoc ? (
          <button
            onClick={() => openMap(inLoc)}
            className="bg-green-500 hover:bg-green-600 text-white text-xs px-3 py-1 rounded"
          >
            IN
          </button>
        ) : (
          <span className="text-gray-400 text-xs">No IN</span>
        )}

        {outLoc ? (
          <button
            onClick={() => openMap(outLoc)}
            className="bg-blue-500 hover:bg-blue-600 text-white text-xs px-3 py-1 rounded"
          >
            OUT
          </button>
        ) : (
          <span className="text-gray-400 text-xs">No OUT</span>
        )}
      </div>
    );
  },
},

    {
      name: "Approved by",
      selector: (row) => (row.ATTENDANCESTATUS === 1 ? row.UserName : ""),
      sortable: true,
    },
  ];

  const tableRef = useRef();

  const exportToPDF = () => {
    const formatDate = (isoDate) => {
      const [year, month, day] = isoDate.split("-");
      return `${day}/${month}/${year}`;
    };

    const fromDateISO =
      dates.FromDate || new Date().toISOString().split("T")[0];
    const toDateISO = dates.ToDate || new Date().toISOString().split("T")[0];

    const fromDate = formatDate(fromDateISO);
    const toDate = formatDate(toDateISO);

    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();

    const tableColumn = [
      "Sl No",
      "Employee Name",
      "Code",
      "Shift",
      "Department",
      "In Time",
      "Out Time",
      "Punch In",
      "Punch Out",
      "Record Date",
      "Working Hours",
      "Attendance",
      "LocationIN",
      "LocationOUT",
    ];

    const recordsByDepartment = {};
    filteredItems?.forEach((row) => {
      const deptName = row.DepartmentName || "Other";
      if (!recordsByDepartment[deptName]) {
        recordsByDepartment[deptName] = [];
      }
      recordsByDepartment[deptName].push(row);
    });

    doc.setProperties({
      title: "Mobile Punched Attendance Report",
      subject: "Attendance Report by Department",
      creator: `${companyDetails.Name}`,
    });

    let currentY = 20;
    let pageCount = 1;

    const addCenteredTitle = () => {
      const title = `${companyDetails?.Name.toUpperCase()} MOBILE PUNCHED ATTENDANCE REPORT`;
      doc.setFontSize(16);
      doc.setTextColor(0, 0, 0);
      const textWidth = doc.getTextWidth(title);
      const xPos = (pageWidth - textWidth) / 2;
      doc.text(title, xPos, 15);

      const dateText = `From: ${fromDate} To: ${toDate}`;
      doc.setFontSize(12);
      const dateWidth = doc.getTextWidth(dateText);
      const dateXPos = (pageWidth - dateWidth) / 2;
      doc.text(dateText, dateXPos, 25);

      return 35;
    };

    currentY = addCenteredTitle();

    Object.entries(recordsByDepartment).forEach(
      ([deptName, records], deptIndex) => {
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(12);
        doc.setFont(undefined, "bold");
        doc.text(`Department: ${deptName}`, 14, currentY);
        doc.setFont(undefined, "normal");
        currentY += 5;

        const tableRows = records.map((row, index) => {
          const [lat, lng] = row.MobilePunchLocation
            ? row.MobilePunchLocation.split(",").map(Number)
            : [null, null];
          const locationKey = lat && lng ? `${lat},${lng}` : null;

          const [latOut, lngOut] = row.LocationOut
            ? row.LocationOut.split(",").map(Number)
            : [null, null];
          const locationKeyOut =
            latOut && lngOut ? `${latOut},${lngOut}` : null;

          return [
            index + 1,
            row.EmployeeName || "",
            row.EmployeeCode || "",
            row.IsWeekly == 1 ? "Weekly Off" : row.ShiftName || "",
            row.DepartmentName || "",
            row.INTIME ? row.INTIME.split("T")[1]?.slice(0, 5) : "-",
            row.OUTTIME ? row.OUTTIME.split("T")[1]?.slice(0, 5) : "-",
            row.PUNCHIN && row.PUNCHIN !== "1900-01-01T00:00:00.000Z"
              ? row.PUNCHIN.split("T")[1]?.slice(0, 5)
              : "-",
            row.PUNCHOUT && row.PUNCHOUT !== "1900-01-01T00:00:00.000Z"
              ? row.PUNCHOUT.split("T")[1]?.slice(0, 5)
              : "-",
            row.RECORDDATE
              ? new Date(row.RECORDDATE).toLocaleDateString("en-GB")
              : "",
            (() => {
              const decimalHour = parseFloat(row.WORKINGHOUR || 0);
              if (!decimalHour) return "-";
              let hours = Math.floor(decimalHour);
              let remainingMinutes = (decimalHour - hours) * 60;
              let minutes = Math.round(remainingMinutes);
              if (minutes === 60) {
                hours += 1;
                minutes = 0;
              }
              const hh = hours.toString().padStart(2, "0");
              const mm = minutes.toString().padStart(2, "0");
              return `${hh}:${mm}`;
            })(),
            (() => {
              const isPunchInDefault =
                !row.PUNCHIN || row.PUNCHIN === "1900-01-01T00:00:00.000Z";
              const isPunchOutDefault =
                !row.PUNCHOUT || row.PUNCHOUT === "1900-01-01T00:00:00.000Z";
              if (row.ATTENDANCESTATUS !== 1) return "Approval Pending";
              if (isPunchInDefault && isPunchOutDefault)
                return "Approved (No Punches)";
              if (isPunchInDefault && !isPunchOutDefault)
                return "Approved (Punch out Only)";
              if (!isPunchInDefault && isPunchOutDefault)
                return "Approved (Punch In Only)";
              return "Approved";
            })(),
            (() => {
              if (!row.MobilePunchLocation) return "-";
              // Now the DB already has the readable address, so no conversion needed
              return row.MobilePunchLocation;
            })(),
            (() => {
              if (!row.LocationOut) return "-";
              // Same for the OUT location
              return row.LocationOut;
            })(),
          ];
        });

        doc.autoTable({
          startY: currentY,
          head: [tableColumn],
          body: tableRows,
          styles: {
            fontSize: 7,
            cellPadding: 2,
            lineColor: [0, 0, 0],
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: [255, 255, 255],
          },
          bodyStyles: {
            fillColor: [255, 255, 255],
          },
          margin: { top: 20, right: 14, bottom: 20, left: 14 },
          tableLineWidth: 0.5,
          tableLineColor: [0, 0, 0],
        });

        currentY = doc.previousAutoTable.finalY + 8;

        if (deptIndex === Object.keys(recordsByDepartment).length - 1) {
          if (currentY > doc.internal.pageSize.height - 40) {
            doc.addPage();
            currentY = 20;
            pageCount++;
            doc.setFontSize(8);
            doc.setTextColor(0, 0, 0);
            doc.text(
              `Page ${pageCount}`,
              doc.internal.pageSize.width - 25,
              doc.internal.pageSize.height - 10
            );
          }

          doc.setFontSize(10);
          doc.setFont(undefined, "bold");
          doc.setTextColor(0, 0, 0);
          doc.text(" Signature:", 14, currentY);
          currentY += 5;
          doc.setLineWidth(0.2);
          doc.line(14, currentY, 64, currentY);
          currentY += 10;
        } else {
          if (currentY > doc.internal.pageSize.height - 40) {
            doc.addPage();
            currentY = addCenteredTitle();
            pageCount++;
            doc.setFontSize(8);
            doc.setTextColor(0, 0, 0);
            doc.text(
              `Page ${pageCount}`,
              doc.internal.pageSize.width - 25,
              doc.internal.pageSize.height - 10
            );
          }
        }
      }
    );

    const today = new Date();
    const generatedText = `Generated on: ${today.toLocaleDateString("en-GB")}`;
    const generatedBy = `Generated by: ${UserName}`;
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    const textWidth = doc.getTextWidth(generatedText);
    const marginRight = 14;
    const lineSpacing = 4;
    doc.text(
      generatedText,
      doc.internal.pageSize.width - textWidth - marginRight,
      doc.internal.pageSize.height - 20
    );
    doc.text(
      generatedBy,
      doc.internal.pageSize.width - textWidth - marginRight,
      doc.internal.pageSize.height - 20 + lineSpacing
    );

    doc.setPage(1);
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    doc.text(
      `Page 1`,
      doc.internal.pageSize.width - 25,
      doc.internal.pageSize.height - 10
    );

    doc.save(`Attendance_Report_${fromDate}_to_${toDate}.pdf`);
  };

  const exportToExcel = () => {
    const fromDate = dates.FromDate || new Date().toISOString().split("T")[0];
    const toDate = dates.ToDate || new Date().toISOString().split("T")[0];

    const recordsByDepartment = {};
    filteredItems?.forEach((row) => {
      const deptName = row.DepartmentName || "Other";
      if (!recordsByDepartment[deptName]) {
        recordsByDepartment[deptName] = [];
      }
      recordsByDepartment[deptName].push(row);
    });

    const workbook = XLSX.utils.book_new();

    Object.entries(recordsByDepartment)?.forEach(([deptName, records]) => {
      const dataToExport = records?.map((row, index) => {
        const [lat, lng] = row.MobilePunchLocation
          ? row.MobilePunchLocation.split(",").map(Number)
          : [null, null];
        const locationKey = lat && lng ? `${lat},${lng}` : null;
        return {
          "Sl No": index + 1,
          "Employee Name": row.EmployeeName || "",
          "Employee Code": row.EmployeeCode || "",
          Shift: row.ShiftName || "",
          Department: row.DepartmentName || "",
          "In Time": row.INTIME ? row.INTIME.split("T")[1]?.slice(0, 5) : "-",
          "Out Time": row.OUTTIME
            ? row.OUTTIME.split("T")[1]?.slice(0, 5)
            : "-",
          "Punch In": row.PUNCHIN
            ? row.PUNCHIN.split("T")[1]?.slice(0, 5)
            : "-",
          "Punch Out": row.PUNCHOUT
            ? row.PUNCHOUT.split("T")[1]?.slice(0, 5)
            : "-",
          "Working Hours": (() => {
            const decimalHour = parseFloat(row.WORKINGHOUR || 0);
            if (!decimalHour) return "-";
            const hours = Math.floor(decimalHour);
            const remainingMinutes = (decimalHour - hours) * 60;
            const minutes = Math.floor(remainingMinutes);
            const seconds = Math.floor((remainingMinutes - minutes) * 60);
            const hh = hours.toString().padStart(2, "0");
            const mm = minutes.toString().padStart(2, "0");
            const ss = seconds.toString().padStart(2, "0");
            return `${hh}:${mm}:${ss}`;
          })(),
          Attendance:
            row.ATTENDANCESTATUS === 1 ? "Approved" : "Approval Pending",
          "Approved By": row.ATTENDANCESTATUS === 1 ? row.UserName : "",
          Location: locationKey
            ? locationCache[locationKey] || "Unknown Location"
            : "-",
        };
      });

      const worksheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [
          [`${companyDetails.Name} Attendance Report`],
          [`From: ${fromDate} To: ${toDate}`],
        ],
        { origin: "A1" }
      );
      worksheet["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 10 } },
        { s: { r: 1, c: 0 }, e: { r: 1, c: 10 } },
      ];
      XLSX.utils.sheet_add_aoa(worksheet, [[`Department: ${deptName}`]], {
        origin: "A3",
      });
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [
          [
            "Sl No",
            "Employee Name",
            "Employee Code",
            "Shift",
            "Department",
            "In Time",
            "Out Time",
            "Punch In",
            "Punch Out",
            "Working Hours",
            "Attendance",
            "Approved By",
            "Location",
          ],
        ],
        { origin: "A4" }
      );
      XLSX.utils.sheet_add_json(worksheet, dataToExport, {
        origin: "A5",
        skipHeader: true,
      });
      const safeDeptName = deptName
        .replace(/[:\\/?*\[\]]/g, "")
        .substring(0, 31);
      XLSX.utils.book_append_sheet(workbook, worksheet, safeDeptName);
    });

    const lastSheetName = workbook.SheetNames[workbook.SheetNames.length - 1];
    const lastSheet = workbook.Sheets[lastSheetName];
    const lastRow = XLSX.utils.decode_range(lastSheet["!ref"] || "A1").e.r + 2;
    XLSX.utils.sheet_add_aoa(
      lastSheet,
      [[`Generated on: ${new Date().toLocaleDateString()}`]],
      { origin: { r: lastRow, c: 0 } }
    );

    XLSX.writeFile(workbook, `Attendance_Report_${fromDate}_to_${toDate}.xlsx`);
  };

  useEffect(() => {
    if (AttendenceReports && AttendenceReports.length > 0) {
      setDataFilter(AttendenceReports);
    } else {
      setDataFilter([]);
    }
  }, [AttendenceReports]);

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);
  };

  const filteredItems = dataFilter?.filter((item) => {
    return (
      item.EmployeeName?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.DepartmentName?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.ShiftName?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.UserName?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.EmployeeCode?.toString()
        .toLowerCase()
        .includes(filterText.toLowerCase())
    );
  });

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [filterPages, setFilterPages] = useState([]);
  const [filterMethod, setFilterMethod] = useState("");

  useEffect(() => {
    const fetchfilterPage = async () => {
      try {
        const response = await getPages(UID);
        const filteredPages = response.data.data.filter((page) =>
          [
            "Category",
            "Profit Center",
            "Group",
            "Designation",
            "Department",
          ].includes(page.Name)
        );
        setFilterPages(filteredPages);
      } catch (error) {
        console.error("Error fetching pages:", error);
      }
    };
    fetchfilterPage();
  }, []);

  const [category, setCategory] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [group, setGroup] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [FilterProfitcenter, setFilterProfitcenter] = useState([]);

  useEffect(() => {
    const fetchcategory = async () => {
      try {
        const response = await getCategorys(UID);
        setCategory(response);
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    };
    fetchcategory();
  }, []);

  useEffect(() => {
    const fetchdesignation = async () => {
      try {
        const response = await getDesignation(UID);
        setDesignation(response);
      } catch (error) {
        console.error("Error fetching designation:", error);
      }
    };
    fetchdesignation();
  }, []);

  useEffect(() => {
    const fetchGroup = async () => {
      try {
        const response = await getGroup(UID);
        setGroup(response);
      } catch (error) {
        console.error("Error fetching group:", error);
      }
    };
    fetchGroup();
  }, []);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await getDepartments(UID);
        setDepartment(response);
      } catch (error) {
        console.error("Error fetching department:", error);
      }
    };
    fetchDepartment();
  }, []);

  useEffect(() => {
    const fetchfilterProfitecenter = async () => {
      try {
        const response = await getProfitCenter(UID);
        setFilterProfitcenter(response);
      } catch (error) {
        console.error("Error fetching profit center:", error);
      }
    };
    fetchfilterProfitecenter();
  }, []);

  useEffect(() => {
    const uniqueShifts = Array.from(
      new Map(filteredItems.map((item) => [item.ShiftId, item])).values()
    );
    const shiftOptions = uniqueShifts.map((el) => ({
      Id: el.ShiftId,
      Name: el.ShiftName,
    }));

    switch (filterMethod) {
      case "CategoryId":
        setDropdownOptions(category?.data?.data);
        break;
      case "ProfitCenterID":
        setDropdownOptions(FilterProfitcenter?.data?.data);
        break;
      case "GroupId":
        setDropdownOptions(group?.data?.data);
        break;
      case "DesignationId":
        setDropdownOptions(designation?.data?.data);
        break;
      case "DepartmentID":
        setDropdownOptions(Department?.data?.data);
        break;
      case "ShiftId":
        setDropdownOptions(shiftOptions);
        break;
      default:
        setDropdownOptions([]);
        break;
    }
  }, [
    filterMethod,
    category,
    FilterProfitcenter,
    group,
    designation,
    Department,
  ]);

  const handleFilterChange = async (selectedMethod, Name, Id) => {
    setFilterMethod(selectedMethod);
    const requestData = {
      UserId: UID,
      name: selectedMethod,
      Id,
      FromDate: dates.FromDate || new Date().toISOString().split("T")[0],
      ToDate: dates.ToDate || new Date().toISOString().split("T")[0],
    };

    try {
      setLoading(true);
      const response = await GetAttendanceReport(requestData);
      const details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DEPARTMENTID == DepId);
      setAttendenceReports(details);
    } catch (error) {
      console.error("Error fetching attendance data", error);
    } finally {
      setLoading(false);
    }
  };

   useEffect(() => {
    fetchCompanyDetails();
    fetchPunchRecords()
  }, []);

  return (
    <div>
      <div className="flex flex-col md:flex-row items-center justify-between mb-8">
        <div className="flex flex-col md:flex-row gap-4 md:gap-[40px] w-full mb-4 md:mb-0">
          <Breadcrumb title="MobilePunch Report" />
          <b className="text-xl">
            Total Employees:{" "}
            {AttendenceReports?.length ? AttendenceReports?.length : 0}
          </b>

          {location.state && (
            <Link to="/" className="ml-auto">
              <button className="btn btn-danger">back</button>
            </Link>
          )}
        </div>

        {AttendenceReports?.length ? (
          <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
            <div className="flex flex-col md:flex-row items-center gap-2 p-5 bg-gray-100 rounded w-full md:w-auto">
              <button
                className="bg-sky rounded-[4px] px-10 py-[8px]"
                onClick={handleFilterClick}
              >
                <IconFilter className="text-white w-[18px] h-[18px]" />
              </button>
              <div className="relative w-full md:w-[400px]">
                <input
                  type="text"
                  id="search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                  placeholder="Search by Emp Name/Code/Dep/shift/Approved by"
                  className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <button
                onClick={handleClear}
                className="btn btn-danger w-full md:w-auto mt-2 md:mt-0"
              >
                Clear
              </button>
            </div>
            <div className="flex flex-row gap-4 w-full md:w-auto justify-center md:justify-start">
              <button
                onClick={exportToExcel}
                className="btn btn-primary w-full md:w-auto"
              >
                Excel
              </button>
              <button
                onClick={exportToPDF}
                className="btn btn-danger w-full md:w-auto"
              >
                PDF
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={AttendenceReports}
          onFilter={handleFilter}
        />
      )}

      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="flex items-center p-4">
          <label
            htmlFor="from-date-input"
            className="text-sm font-medium text-gray-700 mr-2"
          >
            From
          </label>
          <input
            type="date"
            name="FromDate"
            onChange={handleDateChange}
            value={dates.FromDate}
            id="from-date-input"
            className="w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
          />
          <label
            htmlFor="to-date-input"
            className="text-sm font-medium text-gray-700 mx-2"
          >
            To
          </label>
          <input
            type="date"
            name="ToDate"
            onChange={handleDateChange}
            value={dates.ToDate}
            id="to-date-input"
            className="w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
          />
          <button className="btn btn-success ml-4" onClick={handleClick}>
            Show
          </button>
          <select
            id="filter-method"
            name="filter-method"
            className="ml-4 w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
            value={filterMethod}
            onChange={(e) => setFilterMethod(e.target.value)}
          >
            <option value="">Filter By</option>
            <option value="CategoryId">Category</option>
            <option value="ProfitCenterID">Profit Center</option>
            <option value="GroupId">Group</option>
            <option value="DesignationId">Designation</option>
            <option value="DepartmentID">Department</option>
            <option value="ShiftId">Shift</option>
          </select>
          <select
            id="dynamic-options"
            name="dynamic-options"
            className="ml-4 w-[200px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
            onChange={(e) => {
              const selectedOption = dropdownOptions.find(
                (option) => option.Id.toString() === e.target.value
              );
              if (selectedOption) {
                handleFilterChange(
                  filterMethod,
                  selectedOption.Name,
                  selectedOption.Id
                );
              }
            }}
          >
            <option value="" selected>
              Choose One
            </option>
            {dropdownOptions?.length > 0 &&
              dropdownOptions.map((option) => (
                <option key={option.Id} value={option.Id}>
                  {option.Name}
                </option>
              ))}
          </select>
        </div>

        <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <div ref={tableRef}>
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems.length ? filteredItems : []}
                pagination
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
